<template>
  <div class="td-patient-forum">
    <td-divider style="margin-top:100px;">页面正在配置中...</td-divider>
  </div>
</template>

<script>
export default {
  name: "TianDingPatientForumComponent"
};
</script>



// WEBPACK FOOTER //
// src/views/forum/index.vue